import { Spinner } from '@hover/blueprint/brand';
import { Flex } from '@hover/blueprint/chakra';
import React from 'react';

export const DataLoading = () => (
  <Flex
    alignItems="center"
    direction="row"
    height="100%"
    justifyContent="center"
    width="100%"
  >
    <Spinner size="huge" />
  </Flex>
);
